import { headerConstants } from './header.constants';

function setHeader(name, isActive, user) {
    return dispatch => {
        dispatch(
            {
                type: headerConstants.SET_HEADER,
                payload: {
                    name,
                    isActive,
                    user
                }
            })
    };
}

export { setHeader }
